<template>
    <b-navbar toggleable="lg" type="light" variant="light" sticky>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand tag="h1" href="#" :to="'/'">
            <img
                src="../assets/images/mv_logo_trans.png"
                width="30"
                class="d-inline-block align-top mr-2"
            />
            {{ title }}
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav v-if="auth.isAuthentificated">
                <b-nav-item :to="'/'">Übersicht</b-nav-item>
                <b-nav-item-dropdown
                    v-for="(value, key) in menu"
                    :key="key"
                    :text="key"
                >
                    <template v-for="item in value">
                        <template v-if="item.show !== false">
                          <template v-if="item.external !== true">
                            <b-dropdown-item
                                :key="item._links.self.href"
                                :to="item.slug"
                            >{{ item.title }}</b-dropdown-item>
                          </template>
                          <template v-else-if="item.external === true">
                            <b-dropdown-item
                                :key="item._links.self.href"
                                :href="item.slug"
                            >{{ item.title }}</b-dropdown-item>
                          </template>
                        </template>
                    </template>
                </b-nav-item-dropdown>
            </b-navbar-nav>
            <b-navbar-nav v-else>
                <b-nav-item :to="'/'">Anmeldung</b-nav-item>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <!--<b-nav-form v-if="auth.isAuthentificated">
                    <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Suchbegriff" />
                    <b-button
                        size="sm"
                        class="my-2 my-sm-0"
                        variant="outline-success"
                        type="submit"
                    >
                        <font-awesome-icon icon="search" class="mr-1" />Suchen
                    </b-button>
                </b-nav-form>-->

                <b-nav-item-dropdown right v-if="auth.isAuthentificated">
                    <template v-slot:button-content>
                        <b-button size="sm">
                            <font-awesome-icon
                                icon="user"
                                class="mr-1"
                            />Benutzer
                        </b-button>
                    </template>
                    <b-dropdown-header>Angemeldeter Nutzer</b-dropdown-header>
                    <b-dropdown-item disabled>{{
                        auth.username
                    }}</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-header>Version</b-dropdown-header>
                    <b-dropdown-item disabled>{{ version }}</b-dropdown-item>
                    <b-dropdown-item to="/changelog"
                        >Versionshinweis</b-dropdown-item
                    >
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-header>Environment</b-dropdown-header>
                    <b-dropdown-item disabled>{{ env }}</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="showAdminMessagePanel"
                        >Administrator benachrichtigen</b-dropdown-item
                    >
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item to="/settings"
                        >Einstellungen</b-dropdown-item
                    >
                    <b-dropdown-item
                        v-on:click="logout"
                        href="#"
                        class="text-danger"
                        >Abmelden</b-dropdown-item
                    >
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";

export default {
    name: "Navbar",
    mixins: [Toaster],
    computed: {
        auth() {
            return this.$store.getters.getAuth;
        },
        menu() {
            const menu = this.$store.getters.getMenu;
            return menu;
        },
        title() {
            return process.env.VUE_APP_TITLE;
        },
        version() {
            return process.env.VUE_APP_VERSION;
        },
        env() {
            return process.env.VUE_APP_MODE;
        }
    },
    methods: {
        showAdminMessagePanel() {
            this.$root.$emit("bv::show::modal", "adminMessage");
        },
        logout: function() {
          this.$router.push("/logout");
        }
    }
};
</script>
